/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const FEATURE = project.getFeature(feature.getSettingValue('VARIABLE'));
    if (FEATURE) {
        const VARNAME = FEATURE.getSettingValue('VARNAME');

        const links = project.getNodeLinks(feature, 'variable_changed');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: `var_${VARNAME}_changed`,
                blockType: BlockType.CODE,
                template: `/****${link.getSourceId()}****/`,
            });
        }
    }
    return blocks;
};
